import * as React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';

// Styles
const s = require('./../LeadQuestions.css');

// Props
interface IQuestionOptionSelectProps {
  onChange: (changed: { value: any; label: string }) => void;
  optionsTable: string;
  options: Array<{ id: any; name: string }>;
  value: any;
}

// Component
@observer
export class QuestionOptionSelect extends React.Component<
  IQuestionOptionSelectProps,
  {}
> {
  constructor(props: IQuestionOptionSelectProps) {
    super(props);
  }

  @computed private get value(): string | null {
    return this.props.value !== null
      ? typeof this.props.value === 'number'
        ? this.props.value.toString()
        : typeof this.props.value === 'string'
        ? this.props.value
        : typeof this.props.value === 'object' &&
          typeof this.props.value.length !== 'undefined' &&
          this.props.value.length > 0
        ? typeof this.props.value[0].id !== 'undefined'
          ? this.props.value[0].id
          : this.props.value[0]
        : null
      : null;
  }

  public render() {
    const options: JSX.Element[] = [];

    if (this.props.options === null || this.props.options.length <= 0) {
      options.push(
        <option key="option-undefined" value="null-undefined">
          No answers
        </option>
      );
    } else if (this.value === null) {
      options.push(
        <option key="option-initial" value="null-initial">
          Answer
        </option>
      );
    }

    this.props.options.map((option, i) => {
      options.push(
        <option
          key={'option-' + i + '-' + option.id}
          value={
            typeof option.id === 'number' ? option.id.toString() : option.id
          }
        >
          {option.name}
        </option>
      );
    });

    return options.length > 0 ? (
      <div className={s.selectOptionsContainer}>
        <select
          onChange={this.handleSelectChange}
          value={this.value !== null ? this.value : undefined}
        >
          {options}
        </select>
      </div>
    ) : null;
  }

  private handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let optionIndex = -1;
    this.props.options.some((option, i) => {
      if (
        option.id === e.currentTarget.value ||
        option.id === parseInt(e.currentTarget.value, 10)
      ) {
        optionIndex = i;
        return true;
      }

      return false;
    });

    if (optionIndex !== -1 && this.props.onChange) {
      this.props.onChange({
        value: this.props.options[optionIndex].id,
        label: this.props.options[optionIndex].name,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionSelect.tsx